import { Children, useEffect, useState } from "react";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { IListBorderoData } from "src/Contexts/Lancamentos/Contrato/ContratosTypes";
import { UseAutoCompletedAll } from "src/Contexts/Utils/UseAutoCompletedAll";
import { ModalDeleteCore, TableCore, TdCore } from "src/Pages/components";
import { UseVerifyIsPermissionsUser } from "src/Pages/components/hooks/UseVerifyIsPermissionsUser";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import UploadIcon from '@mui/icons-material/Upload';
import {
  EditIcon,
  CheckIcon,
  CloseIcon,
  BackspaceIcon,
  FindInPageIcon,
  DeleteForeverIcon,
  CurrencyExchangeIcon,
  RemoveRedEyeIcon,
  ReceiptIcon,
} from "src/Pages/components/Icons/Icons";
import { UseDelete } from "src/Pages/components/ModalDeleteCore/Hooks/UseDelete";
import { TableRowCore } from "src/Pages/components/table/@Core/TableRowCore/TableRowCore";
import { ActionPopoverTable } from "src/Pages/components/table/ActionPopover/ActionPopover";
import { FormatDateBR, GetDateUSSemValue } from "src/shared/Utils/FormatDateBR";
import { FormatMoney } from "src/shared/Utils/FormatMoney";
import { handleFormatDateIfIsNull } from "src/shared/Utils/handleFormatDateIfIsNull";
import { cpfOurCnpj } from "src/shared/Utils/MaskCpfCnpj";
import { valuesPermissions } from "src/shared/Utils/ValuesPermissions";

import { ModalCancelarPagamentoBordero } from "../Components/CancelarPagamento/ModalCancelarPagamento";
import { FilterSidebarBordero } from "../Components/FilterSidebar/FilterSidebar";
import { ModalCancelarReceberParcela } from "../Components/ModalCancelarReceberParcela/ModalCancelarReceberParcela";
import { ModalEditarParcela } from "../Components/ModalEditarParcela/FormEditarParcela";
import { ModalNovaParcela } from "../Components/ModalNovaParcela";
import { ModalReceberParcela } from "../Components/ModalParcelaReceber";
import { ModalVisualizarParcela } from "../Components/ModalVisualizarParcela";
import { QuickFiltersParcelas, useQuickFiltersParcelas, TQuickFilterId } from "../Components/QuickFiltersParcelas";
import { handleDownloadReciboRecebimento } from "../Components/ReciboRecebimento/ReciboRecebimentoPDF";

import { useHttpTableBordero } from "./Hooks/useHttpTableBordero";
import { THeadBordero } from "./THead";
import { statusContract } from "../../0 - Contratos/Components/FormCancelContrato/FormCancelContrato";
import { objStatusContractColor } from "../../0 - Contratos/Components/table/TableContratos";
import { Box, Chip, IconButton, Menu, Typography } from "@mui/material";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";
import { UrlConfig } from "src/shared/Utils/paths";
import { LinkCore } from "src/Pages/components/LinkCore/LinkCore";
import { CardsMetricsParcelas } from "../Components/CardsMetricsParcelas/CardsMetricsParcelas";
import { useGetSheetBordero } from "./Hooks/useGetSheetParcelas";

interface ITableInstallments {
  idContract?: string;
}

export const TableBordero = ({ idContract: id }: ITableInstallments) => {
  const { handleVerifyPermissionItem } = UseVerifyIsPermissionsUser();
  const { handleGet } = useHttpTableBordero();
  const { userPerfil } = useAuthContext();

  const { handleGetSheetBordero, loading: loadingGetSheetBordero } = useGetSheetBordero();

  const {
    setNameSearch,
    itensPerPage,
    currentPage,
    nameSearch,
    attTable,
    setId,
  } = useConfigPageContext();

  const { listBordero, valuesFilterBordero, setValuesInputsBorderoParcela, orderTable, } =
    useContextContrato();

  const { valueAutoCompOperadoraFilter, valueAutoCompAdministradora } =
    UseAutoCompletedAll();

  const {
    activeFilters,
    toggleFilter,
    clearFilters,
    getCombinedFilterParams,
  } = useQuickFiltersParcelas();

  const executeFilterSearch = (filterParams: ReturnType<typeof getCombinedFilterParams>) => {
    handleGet({
      id_contrato: id,
      currentPage: 1,
      itensPerPage,
      nameSearch,
      orderTable,
      codeOperadora: valueAutoCompOperadoraFilter.id,
      codProposta: valuesFilterBordero.cod_proposta,
      codeAdministradora: valueAutoCompAdministradora.id,

      startDateSignature: valuesFilterBordero.startDateSignature,
      endDateSignature: valuesFilterBordero.endDateSignature,

      endDueDate: filterParams.endDueDate || "",
      startDueDate: filterParams.startDueDate || "",

      startDateEmission: valuesFilterBordero.startDateEmission,
      endDateEmission: valuesFilterBordero.endDateEmission,

      startDateReceipt: filterParams.startDateReceipt || "",
      endDateReceipt: filterParams.endDateReceipt || "",

      installmentNumber: valuesFilterBordero.installmentNumber,

      installmentReceipt: filterParams.installmentReceipt || "ALL",

      isInstallmentBroker: valuesFilterBordero.isInstallmentBroker,
      isInstallmentSupervisor: valuesFilterBordero.isInstallmentSupervisor,
      isInstallmentManager: valuesFilterBordero.isInstallmentManager,

      isVitalicioCorretora: valuesFilterBordero.isVitalicioCorretora,
      isVitalicioCorretor: valuesFilterBordero.isVitalicioCorretor,
      isVitalicioSupervisor: valuesFilterBordero.isVitalicioSupervisor,
      isVitalicioGerente: valuesFilterBordero.isVitalicioGerente,
      isDeleted: valuesFilterBordero.isDeleted,

      installmentNumberOperator: valuesFilterBordero.installmentNumberOperator,

      client: {
        nameOrRazao: valuesFilterBordero.nameOrRazao,
        cpfCnpj: valuesFilterBordero.cpfCnpj,
      },
    });
  };

  const handleQuickFilterToggle = (filterId: TQuickFilterId) => {
    const newFilters = toggleFilter(filterId);
    const filterParams = getCombinedFilterParams(newFilters);
    executeFilterSearch(filterParams);
  };

  const handleClearQuickFilters = () => {
    clearFilters();
    const filterParams = getCombinedFilterParams([]);
    executeFilterSearch(filterParams);
  };

  const [openModalReceberParcela, setOpenModalReceberParcela] = useState(false);
  const [openModalCancelReceber, setOpenModalCancelReceber] = useState(false);
  const [openModalEditarParcela, setOpenModalEditarParcela] = useState(false);
  const [openModalNovaParcela, setOpenModalNovaParcela] = useState(false);

  const [openModalCancelarPagamento, setOpenModalCancelarPagamento] =
    useState(false);
  const [openModalVisualizarParcela, setOpenModalVisualizarParcela] =
    useState(false);
  const [parcelaSelecionada, setParcelaSelecionada] = useState<IListBorderoData | undefined>(undefined);

  const [openModalCancelarProducer, setOpenModalCancelarProducer] = useState<
    "CORRETOR" | "SUPERVISOR" | "GERENTE"
  >("CORRETOR");

  useEffect(() => {
    // Se houver filtros rápidos ativos, usar os valores calculados dinamicamente
    const quickFilterParams = activeFilters.length > 0
      ? getCombinedFilterParams(activeFilters)
      : null;

    // Se houver filtros rápidos ativos, eles têm precedência sobre os valores do contexto
    const hasQuickFilters = activeFilters.length > 0;

    handleGet({
      id_contrato: id,
      currentPage,
      itensPerPage,
      nameSearch,
      orderTable,
      codeOperadora: valueAutoCompOperadoraFilter.id,
      codProposta: valuesFilterBordero.cod_proposta,
      codeAdministradora: valueAutoCompAdministradora.id,

      startDateSignature: valuesFilterBordero.startDateSignature,
      endDateSignature: valuesFilterBordero.endDateSignature,

      // Se houver filtros rápidos ativos, usar seus valores (mesmo que vazios)
      // Caso contrário, usar os valores do contexto
      endDueDate: hasQuickFilters
        ? (quickFilterParams?.endDueDate || "")
        : (valuesFilterBordero.endDueDate || ""),
      startDueDate: hasQuickFilters
        ? (quickFilterParams?.startDueDate || "")
        : (valuesFilterBordero.startDueDate || ""),

      startDateEmission: valuesFilterBordero.startDateEmission,
      endDateEmission: valuesFilterBordero.endDateEmission,

      // Se houver filtros rápidos ativos, usar seus valores (mesmo que vazios)
      // Caso contrário, usar os valores do contexto
      startDateReceipt: hasQuickFilters
        ? (quickFilterParams?.startDateReceipt || "")
        : (valuesFilterBordero.startDateReceipt || ""),
      endDateReceipt: hasQuickFilters
        ? (quickFilterParams?.endDateReceipt || "")
        : (valuesFilterBordero.endDateReceipt || ""),

      installmentNumber: valuesFilterBordero.installmentNumber,

      // Se houver filtros rápidos ativos, usar seu valor
      // Caso contrário, usar o valor do contexto
      installmentReceipt: hasQuickFilters
        ? (quickFilterParams?.installmentReceipt || "ALL")
        : (valuesFilterBordero.installmentReceipt || "ALL"),

      isInstallmentBroker: valuesFilterBordero.isInstallmentBroker,
      isInstallmentSupervisor: valuesFilterBordero.isInstallmentSupervisor,
      isInstallmentManager: valuesFilterBordero.isInstallmentManager,

      installmentNumberOperator: valuesFilterBordero.installmentNumberOperator,

      isVitalicioCorretora: valuesFilterBordero.isVitalicioCorretora,
      isVitalicioCorretor: valuesFilterBordero.isVitalicioCorretor,
      isVitalicioSupervisor: valuesFilterBordero.isVitalicioSupervisor,
      isVitalicioGerente: valuesFilterBordero.isVitalicioGerente,
      isDeleted: id ? "ALL" : valuesFilterBordero.isDeleted,

      client: {
        nameOrRazao: valuesFilterBordero.nameOrRazao,
        cpfCnpj: valuesFilterBordero.cpfCnpj,
      },
    });
  }, [attTable, itensPerPage, currentPage, nameSearch, orderTable, activeFilters, getCombinedFilterParams]);

  const {
    handleDelete,
    open: openModalDelete,
    loading: loadingDelete,
    setId: setIdModalDelete,
    setOpen: setOpenModalDelete,
  } = UseDelete({ url: "/bordero" });

  const handleReceberParcela = (item: IListBorderoData) => {
    setId(item.id);
    setOpenModalReceberParcela(true);

    setValuesInputsBorderoParcela({
      id: item.id,
      contratos_vidas: item.contratos_vidas,
      observacao: item.observacao || "",
      tipo_desconto_parcela: "VALOR",
      valor_recebido: !item.valor_recebido
        ? FormatMoney(item.valor_contrato)
        : FormatMoney(item.valor_recebido),
      desconto_parcela: "",
      total_com_desconto: !item.valor_recebido
        ? FormatMoney(item.valor_contrato)
        : FormatMoney(item.valor_recebido),
      data_recebimento: !item.data_recebimento
        ? `${GetDateUSSemValue()}`
        : handleFormatDateIfIsNull(item.data_recebimento),
      data_previsao: handleFormatDateIfIsNull(item.data_previsao),
      valor_comissao_corretor: FormatMoney(item.valor_comissao_corretor) || "",
      valor_comissao_corretora: FormatMoney(item.valor_comissao_corretora) || "",
      valor_comissao_gerente: FormatMoney(item.valor_comissao_gerente) || "",
      valor_comissao_supervisor: FormatMoney(item.valor_comissao_supervisor) || "",
      porcentagem_comissao_corretora: item.porcentagem_comissao_corretora || "",
      porcentagem_comissao_corretor: item.porcentagem_comissao_corretor || "",
      porcentagem_comissao_gerente: item.porcentagem_comissao_gerente || "",
      porcentagem_comissao_supervisor: item.porcentagem_comissao_supervisor || "",
      id_corretor: item.id_corretor || "",
      id_supervisor: item.id_supervisor || "",
      id_gerente: item.id_gerente || "",
    });
  };

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <TableCore
        Modals={
          <>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
              transformOrigin={{ vertical: 'top', horizontal: 'center', }}
              slotProps={{ paper: { sx: { width: "240px", } } }}
            >
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                sx={{ p: 2, }}
              >
                <Typography
                  fontSize="13px"
                  color="text.secondary"
                  fontWeight={500}
                  textAlign="center"
                  mb={1}
                >
                  Baixe todos os contratos em Excel <br /> conforme o filtro que você aplicou.
                </Typography>
                <ButtonCore
                  title="Baixar Excel"
                  variant="contained"
                  disabled={loadingGetSheetBordero}
                  onClick={() => {
                    handleGetSheetBordero({
                      id_contrato: id,
                      currentPage,
                      itensPerPage,
                      nameSearch,
                      orderTable,
                      codeOperadora: valueAutoCompOperadoraFilter.id,
                      codProposta: valuesFilterBordero.cod_proposta,
                      codeAdministradora: valueAutoCompAdministradora.id,

                      startDateSignature: valuesFilterBordero.startDateSignature,
                      endDateSignature: valuesFilterBordero.endDateSignature,

                      endDueDate: valuesFilterBordero.endDueDate,
                      startDueDate: valuesFilterBordero.startDueDate,

                      startDateEmission: valuesFilterBordero.startDateEmission,
                      endDateEmission: valuesFilterBordero.endDateEmission,

                      startDateReceipt: valuesFilterBordero.startDateReceipt,
                      endDateReceipt: valuesFilterBordero.endDateReceipt,

                      installmentNumber: valuesFilterBordero.installmentNumber,

                      installmentReceipt: valuesFilterBordero.installmentReceipt,

                      isInstallmentBroker: valuesFilterBordero.isInstallmentBroker,
                      isInstallmentSupervisor: valuesFilterBordero.isInstallmentSupervisor,
                      isInstallmentManager: valuesFilterBordero.isInstallmentManager,

                      isVitalicioCorretora: valuesFilterBordero.isVitalicioCorretora,
                      isVitalicioCorretor: valuesFilterBordero.isVitalicioCorretor,
                      isVitalicioSupervisor: valuesFilterBordero.isVitalicioSupervisor,
                      isVitalicioGerente: valuesFilterBordero.isVitalicioGerente,
                      
                      isDeleted: valuesFilterBordero.isDeleted,

                      installmentNumberOperator: valuesFilterBordero.installmentNumberOperator,

                      client: {
                        nameOrRazao: valuesFilterBordero.nameOrRazao,
                        cpfCnpj: valuesFilterBordero.cpfCnpj,
                      },
                    });
                  }}
                  sx={{
                    mt: 1,
                    color: "#fff",
                    boxShadow: "0 1px 7px 0 rgba(8,80,160,0.13)",
                    fontWeight: 600,
                    letterSpacing: ".03em",
                    textTransform: "none",
                    px: 2,
                    py: .7,
                    fontSize: "13px",
                    transition: "background 0.3s",
                  }}
                  startIcon={<SaveAltIcon />}
                />
              </Box>
            </Menu>
            <ModalReceberParcela
              openModal={openModalReceberParcela}
              setOpenModal={setOpenModalReceberParcela}
            />

            <ModalCancelarReceberParcela
              modalDelete={openModalCancelReceber}
              setModalDelete={setOpenModalCancelReceber}
            />

            <ModalCancelarPagamentoBordero
              funcao_produtor={openModalCancelarProducer}
              modalCancelarPagamento={openModalCancelarPagamento}
              setModalCancelarPagamento={setOpenModalCancelarPagamento}
            />

            <ModalEditarParcela
              openModal={openModalEditarParcela}
              setOpenModal={setOpenModalEditarParcela}
            />

            <ModalVisualizarParcela
              openModal={openModalVisualizarParcela}
              setOpenModal={setOpenModalVisualizarParcela}
              parcela={parcelaSelecionada as IListBorderoData | null}
            />

            <ModalDeleteCore
              loading={loadingDelete}
              modalOpen={openModalDelete}
              no="Não, Cancelar"
              titlePrimary="Você deseja excluir parcela ?"
              yes="Sim, Deletar !"
              onClickFalse={() => setOpenModalDelete(false)}
              onClickTrue={() => handleDelete()}
            />
          </>
        }
        THead={<THeadBordero />}
        cardAdd={{
          title: "Parcelas",
          icon: <FindInPageIcon color="primary" />,
          subTitle: "Controle o recebimento e pagamento das parcelas, criar novas parcelas e importação automática.",
          buttonAdd: [
            <ButtonCore
              id="basic-button"
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
              variant="outlined"
              title="Baixar Excel"
              startIcon={<SaveAltIcon />}
            />,
            !id && (
              <LinkCore to={UrlConfig.lancamentos.importInstallments.url} isDisabled>
                <ButtonCore
                  startIcon={<UploadIcon />}
                  key={1}
                  title="Importar parcelas"
                  color="secondary"
                  disabled={true}
                />
              </LinkCore>
            ),
            // !id && (
            //   <ModalUploadCommission
            //     key={1}
            //     openModal={openModalUploadCommission}
            //     setOpenModal={setOpenModalUploadCommission}
            //   />
            // ),
            <ModalNovaParcela
              key={1}
              id={id as string}
              openModal={openModalNovaParcela}
              setOpenModal={setOpenModalNovaParcela}
            />,
          ],
        }}
        filter={<FilterSidebarBordero clearFilters={handleClearQuickFilters} />}
        qtdList={listBordero.data.length}
        setNameSearch={!id ? setNameSearch : undefined}
        metrics={
          <Box sx={{ marginBottom: "24px" }}>
            <CardsMetricsParcelas data={listBordero.metrics} />
            <Box sx={{ marginTop: "16px" }}>
              <QuickFiltersParcelas
                activeFilters={activeFilters}
                onFilterToggle={handleQuickFilterToggle}
                onClearFilters={handleClearQuickFilters}
              />
            </Box>
          </Box>
        }
      >
        {Children.toArray(
          listBordero.data.map((item) => {
            return (
              <TableRowCore id={item.id}>
                <TdCore
                  values={
                    <ActionPopoverTable
                      optionsList={[
                        {
                          icon: <CurrencyExchangeIcon fontSize="small" />,
                          title: "Receber",
                          background: "success",
                          isDisabled:
                            handleVerifyPermissionItem(
                              valuesPermissions.BORDERO.RECEBER.id
                            ) || item.is_parcela_recebida,
                          onClick: () => handleReceberParcela(item),
                        },
                        {
                          icon: <RemoveRedEyeIcon fontSize="small" />,
                          title: "Visualizar parcela",
                          background: "success",

                          onClick: () => {
                            setParcelaSelecionada(item);
                            setOpenModalVisualizarParcela(true);
                          },
                        },
                        {
                          icon: <ReceiptIcon fontSize="small" />,
                          title: "Gerar recibo de recebimento",
                          background: "info",
                          isDisabled: !item.is_parcela_recebida,
                          onClick: () => {
                            handleDownloadReciboRecebimento(
                              item,
                              userPerfil?.empresa.nome
                            );
                          },
                        },
                        {
                          icon: (
                            <BackspaceIcon
                              fontSize="small"
                              sx={{ fontSize: ".9rem" }}
                            />
                          ),
                          background: "warning",
                          title: "Zerar recebimento",
                          onClick: () => {
                            setId(item.id);
                            setOpenModalCancelReceber(true);
                          },
                          isDisabled:
                            handleVerifyPermissionItem(
                              valuesPermissions.BORDERO.ZERAR_RECEBIMENTO.id
                            ) || !item.is_parcela_recebida,
                        },
                        // {
                        //   icon: <MoneyOffIcon fontSize="small" />,
                        //   title: "Zerar pagamento CORRETOR",
                        //   background: "error",
                        //   onClick: () => {
                        //     setId(item.id);
                        //     setOpenModalCancelarPagamento(true);
                        //     setOpenModalCancelarProducer("CORRETOR");
                        //   },
                        //   isDisabled:
                        //     handleVerifyPermissionItem(
                        //       valuesPermissions.BORDERO.VOLTAR_PAGAMENTO.id
                        //     ) || !item.is_recibo_corretor,
                        // },
                        // {
                        //   icon: <MoneyOffIcon fontSize="small" />,
                        //   title: "Zerar pagamento SUPERVISOR",
                        //   background: "error",
                        //   onClick: () => {
                        //     setId(item.id);
                        //     setOpenModalCancelarPagamento(true);
                        //     setOpenModalCancelarProducer("SUPERVISOR");
                        //   },
                        //   isDisabled:
                        //     handleVerifyPermissionItem(
                        //       valuesPermissions.BORDERO.VOLTAR_PAGAMENTO.id
                        //     ) || !item.is_recibo_supervisor,
                        // },
                        // {
                        //   icon: <MoneyOffIcon fontSize="small" />,
                        //   title: "Zerar pagamento GERENTE",
                        //   background: "error",
                        //   onClick: () => {
                        //     setId(item.id);
                        //     setOpenModalCancelarPagamento(true);
                        //     setOpenModalCancelarProducer("GERENTE");
                        //   },
                        //   isDisabled:
                        //     handleVerifyPermissionItem(
                        //       valuesPermissions.BORDERO.VOLTAR_PAGAMENTO.id
                        //     ) || !item.is_recibo_gerente,
                        // },
                        {
                          icon: <EditIcon fontSize="small" />,
                          title: "Editar",
                          background: "warning",
                          isDisabled: handleVerifyPermissionItem(
                            valuesPermissions.BORDERO.EDITAR.id
                          ),
                          onClick: () => {
                            setId(item.id);
                            setOpenModalEditarParcela(true);
                          },
                        },
                        {
                          icon: <DeleteForeverIcon fontSize="small" />,
                          title: "Excluir",
                          isDisabled: handleVerifyPermissionItem(
                            valuesPermissions.BORDERO.DELETAR.id
                          ),
                          background: "error",
                          onClick: () => {
                            setIdModalDelete(item.id);
                            setOpenModalDelete(true);
                          },
                        },
                      ]}
                    />
                  }
                />

                <TdCore
                  textAlign="center"
                  values={
                    <IconButton
                      size="small"
                      onClick={() => {
                        setParcelaSelecionada(item);
                        setOpenModalVisualizarParcela(true);
                      }}
                    >
                      <RemoveRedEyeIcon fontSize="small" sx={{ color: "#A6A6A6FF" }} />
                    </IconButton>
                  }
                />


                <TdCore
                  textAlign="center"
                  values={<Chip label={item.cod_proposta} color="default" sx={{ padding: "0 6px", minWidth: "100px" }} />}
                />
                <TdCore
                  textAlign="center"
                  values={<Chip
                    label={String(item.numero_parcela) === "0" ? "Adesão" : item.numero_parcela}
                    color="default"
                    sx={{ padding: "0 6px", minWidth: "30px" }}
                  />}
                />
                <TdCore
                  isLimit
                  isLimitQTD={35}
                  textAlign="left"
                  values={item.tipo_contrato === "PF"
                    ? item.titular_pf
                    : item.razao_social_pj}
                  subTitle={item.tipo_contrato === "PF"
                    ? cpfOurCnpj({ text: item.cpf_cnpj, type: "cpf" })
                    : cpfOurCnpj({ text: item.cpf_cnpj, type: "cnpj" })}

                />
                <TdCore textAlign="center" values={item.contratos_vidas} />

                <TdCore
                  textAlign="left"
                  values={`${item.code_operadoras} - ${item.name_operadoras}`}
                  subTitle={`${item.code_modalidades} - ${item.name_modalidades}`}
                />
                <TdCore
                  color="#0e6aff"
                  textAlign="center"
                  values={item.data_vencimento_parcela ? FormatDateBR(item.data_vencimento_parcela) : ""}
                />

                <TdCore
                  textAlign="center"
                  values={
                    (() => {
                      if (item.is_parcela_recebida) {
                        return (
                          <Chip
                            sx={{ backgroundColor: "#EBF9EF", color: "#069A35FF", minWidth: "100%", maxHeight: "28px" }}
                            label="Recebida"
                            icon={<CheckIcon color="success" sx={{ fontSize: ".9rem" }} />}
                          />
                        );
                      }
                      const vencimento = item.data_vencimento_parcela;
                      const hoje = GetDateUSSemValue();

                      if (vencimento && vencimento < hoje) {
                        return (
                          <Chip
                            sx={{ backgroundColor: "#FEF2F2", color: "#EF4444", minWidth: "100%", maxHeight: "28px" }}
                            label="Vencida"
                            icon={<CloseIcon color="error" sx={{ fontSize: ".9rem" }} />}
                          />
                        );
                      }
                      return (
                        <Chip
                          sx={{ backgroundColor: "#EDEDEDC0", color: "#6d6d6d", minWidth: "100%", maxHeight: "28px" }}
                          label="Pendente"
                          icon={<CloseIcon sx={{ fontSize: ".9rem", color: "#6d6d6d" }} />}
                        />
                      );
                    })()}
                />
                <TdCore
                  color="#3cb916"
                  textAlign="left"
                  values={item.is_parcela_recebida ? `R$ ${item.valor_recebido || ""}` : ""}
                />
                <TdCore
                  // borderBottom={item.data_recebimento ? "1px solid  #0e6aff" : ""}
                  color="#0e6aff"
                  textAlign="center"
                  values={
                    item.data_recebimento
                      ? FormatDateBR(item.data_recebimento)
                      : ""
                  }
                />
                <TdCore
                  textAlign="center"
                  tooltip={item.data_recibo_corretor ? FormatDateBR(item.data_recibo_corretor) : ""}
                  values={
                    item.valor_comissao_corretor !== "0.00" ? (
                      item.is_recibo_corretor ? (
                        <CheckIcon color="success" fontSize="small" />
                      ) : (
                        <CloseIcon color="error" fontSize="small" />
                      )
                    ) : (
                      "-"
                    )
                  }
                />
                <TdCore
                  textAlign="center"
                  tooltip={
                    item.data_recibo_supervisor
                      ? FormatDateBR(item.data_recibo_supervisor)
                      : ""
                  }
                  values={
                    item.valor_comissao_supervisor !== "0.00" ? (
                      item.is_recibo_supervisor ? (
                        <CheckIcon color="success" fontSize="small" />
                      ) : (
                        <CloseIcon color="error" fontSize="small" />
                      )
                    ) : (
                      "-"
                    )
                  }
                />
                <TdCore
                  textAlign="center"
                  tooltip={
                    item.data_recibo_gerente
                      ? FormatDateBR(item.data_recibo_gerente)
                      : ""
                  }
                  values={
                    item.valor_comissao_gerente !== "0.00" ? (
                      item.is_recibo_gerente ? (
                        <CheckIcon color="success" fontSize="small" />
                      ) : (
                        <CloseIcon color="error" fontSize="small" />
                      )
                    ) : (
                      "-"
                    )
                  }
                />

                <TdCore
                  color={Number(item.valor_divergente_contrato_to_recebido) >= 0 ? "#3cb916" : "#FF4E48FF"}
                  values={`R$ ${FormatMoney(item.valor_divergente_contrato_to_recebido || "0.00")}`}
                />

                <TdCore color="#3cb916" values={`R$ ${FormatMoney(item.valor_contrato)}`} />
                <TdCore
                  color="#3cb916"
                  values={
                    <Box display="flex" alignItems="center" gap={1}>
                      {`R$ ${FormatMoney(item.valor_comissao_corretora)}`}

                      {item.is_vitalicio_corretora && <AllInclusiveIcon fontSize="small" color="primary" />}
                    </Box>
                  }
                />

                <TdCore
                  color="#3cb916"
                  values={
                    <Box display="flex" alignItems="center" gap={1}>
                      {`R$ ${FormatMoney(item.valor_comissao_corretor)}`}

                      {item.is_vitalicio_corretor && <AllInclusiveIcon fontSize="small" color="primary" />}
                    </Box>
                  }
                />
                <TdCore
                  color="#3cb916"
                  values={
                    <Box display="flex" alignItems="center" gap={1}>
                      {`R$ ${FormatMoney(item.valor_comissao_supervisor || "0.00")}`}

                      {item.is_vitalicio_supervisor && <AllInclusiveIcon fontSize="small" color="primary" />}
                    </Box>
                  }
                />
                <TdCore
                  color="#3cb916"
                  values={
                    <Box display="flex" alignItems="center" gap={1}>
                      {`R$ ${FormatMoney(item.valor_comissao_gerente || "0.00")}`}

                      {item.is_vitalicio_gerente && <AllInclusiveIcon fontSize="small" color="primary" />}
                    </Box>
                  }
                />
                <TdCore
                  color="#3cb916"
                  values={`R$ ${FormatMoney(String(item.valor_lucro_parcela || "0.00"))}`}
                />

                <TdCore
                  color="#3980f5"
                  values={
                    <Box display="flex" alignItems="center" gap={1}>
                      {`${item.porcentagem_comissao_corretora.replace(".", ",") ||
                        "0,00%"
                        }%`}

                      {item.is_vitalicio_corretora && <AllInclusiveIcon fontSize="small" color="primary" />}
                    </Box>
                  }
                />
                <TdCore
                  color=" #3980f5"
                  values={
                    <Box display="flex" alignItems="center" gap={1}>
                      {`${item.porcentagem_comissao_corretor.replace(".", ",") ||
                        "0,00%"
                        }%`}

                      {item.is_vitalicio_corretor && <AllInclusiveIcon fontSize="small" color="primary" />}
                    </Box>
                  }
                />
                <TdCore
                  color=" #3980f5"
                  values={
                    <Box display="flex" alignItems="center" gap={1}>
                      {`${item.porcentagem_comissao_supervisor.replace(".", ",") ||
                        "0,00%"
                        }%`}

                      {item.is_vitalicio_supervisor && <AllInclusiveIcon fontSize="small" color="primary" />}
                    </Box>
                  }
                />
                <TdCore
                  color=" #3980f5"
                  values={
                    <Box display="flex" alignItems="center" gap={1}>
                      {`${item.porcentagem_comissao_gerente.replace(".", ",") ||
                        "0,00%"
                        }%`}

                      {item.is_vitalicio_gerente && <AllInclusiveIcon fontSize="small" color="primary" />}
                    </Box>
                  }
                />
                <TdCore values={`${item.id_corretor} - ${item.nome_produtor}`} />

                <TdCore values={`${item.id_supervisor || ""} - ${item.nome_supervisor || ""}`} />
                <TdCore values={`${item.id_gerente || ""} - ${item.nome_gerente || ""}`} />
                <TdCore
                  color={item.tipo_contrato === "PF" ? "#e4a022" : "#9357f5"}
                  textAlign="center"
                  values={item.tipo_contrato.toUpperCase()}
                />

                <TdCore
                  color={item.is_deleted ? "#D0021B" : objStatusContractColor[item.status_contratos]}
                  values={item.is_deleted ? "Contrato deletado" : statusContract[item.status_contratos]}
                  sxStyle={{ fontSize: ".7rem" }}
                />

                <TdCore values={item.observacao} />
              </TableRowCore>
            );
          })
        )}
      </TableCore>
    </>
  );
};
